import React from "react";
import { observer } from "mobx-react";
import { observable, action } from "mobx";
import { injectIntl } from "react-intl";
import PropTypes from "prop-types";
import Select from "react-select-plus";
import 'react-select-plus/dist/react-select-plus.css';
import { ButtonToolbar, Button, Clearfix } from "react-bootstrap";

@injectIntl
@observer
export default class TodosSavePanel extends React.Component {
  constructor(props) {
    super(props);

    this.SAVE_MODAL_RADIO = {
      NEW_PRESET: "newPreset",
      OVERWRITE_PRESET: "overwritePreset"
    };
  }

  @observable text = "";
  @observable selectedOption = undefined;
  @observable selectedRadio = this.SAVE_MODAL_RADIO.NEW_PRESET;

  render() {
    const { note, intl } = this.props;
    const { formatMessage } = intl;

    const todoListOptions = note.cardTodoLists.map(todoList => ({
      value: todoList,
      label: `${todoList.name} (${todoList.items.length})`
    }));

    const saveButtonDisabled =
      (this.selectedRadio === this.SAVE_MODAL_RADIO.NEW_PRESET &&
        !this.text.trim()) ||
      (this.selectedRadio === this.SAVE_MODAL_RADIO.OVERWRITE_PRESET &&
        !this.selectedOption);

    const showOverwrite = note.cardTodoLists.length > 0;

    return (
      <div className="note-todos-save-container">
        <label>
          <input
            type="radio"
            style={{ marginRight: "5px" }}
            value={this.SAVE_MODAL_RADIO.NEW_PRESET}
            checked={this.selectedRadio === this.SAVE_MODAL_RADIO.NEW_PRESET}
            onChange={action(e => (this.selectedRadio = e.target.value))}
          />
          {formatMessage({ id: "save_todo_list_as_preset" })}
        </label>

        <input
          className="form-control"
          autoFocus
          onChange={action(e => (this.text = e.target.value))}
        />

        {showOverwrite && (
          <React.Fragment>
            <label>
              <input
                type="radio"
                style={{ marginRight: "5px" }}
                value={this.SAVE_MODAL_RADIO.OVERWRITE_PRESET}
                checked={
                  this.selectedRadio === this.SAVE_MODAL_RADIO.OVERWRITE_PRESET
                }
                onChange={action(e => (this.selectedRadio = e.target.value))}
              />
              {formatMessage({ id: "todo_list_overwrite_preset" })}
            </label>

            <Select
              onChange={option => (this.selectedOption = option)}
              value={this.selectedOption}
              options={todoListOptions}
              clearable={false}
            />
          </React.Fragment>
        )}
        <br />
        <br />

        <ButtonToolbar className="pull-right">
          <Button onClick={() => note.toggleTodoManagePanel()}>
            {formatMessage({ id: "cancel" })}
          </Button>

          <Button
            bsStyle="primary"
            onClick={this.saveTodoList}
            disabled={saveButtonDisabled}
          >
            {formatMessage({ id: "save" })}
          </Button>
        </ButtonToolbar>

        <Clearfix />
      </div>
    );
  }

  @action saveTodoList = () => {
    const { note } = this.props;

    if (this.selectedRadio === this.SAVE_MODAL_RADIO.NEW_PRESET) {
      note.addTodoList(this.text);
    } else {
      note.updateTodoListItems(this.selectedOption.value);
    }
    this.toggleSaveModal();
  };

  @action
  toggleSaveModal = () => {
    const { note } = this.props;

    // note.toggleTodoSaveModal();
    note.toggleTodoManagePanel();

    this.text = "";
    this.selectedRadio = this.SAVE_MODAL_RADIO.NEW_PRESET;
    this.selectedOption = undefined;
  };
}

TodosSavePanel.propTypes = {
  note: PropTypes.object.isRequired
};
